import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YoutubeIcon from '@mui/icons-material/YouTube';
import SitemarkIcon from './SitemarkIcon.tsx';
import { Link as RouterLink, useNavigate } from 'react-router-dom';

function Copyright() {
  return (
    <Typography variant="body2" sx={{ color: 'text.secondary', mt: 1 }}>
      {'Copyright © '}
      <Link color="text.secondary" href="https://www.linkedin.com/company/105314428">
        ATISALISTECH SOLUTIONS PRIVATE LIMITED
      </Link>
      &nbsp;
      {new Date().getFullYear()}
    </Typography>
  );
}

export default function Footer() {
  const navigate = useNavigate();
  const openSection = React.useCallback((sectionName) => {
      const selectedHomeSection = document.getElementById(sectionName);
      if (selectedHomeSection) {
        selectedHomeSection.scrollIntoView({ behavior: 'smooth' });
      } else {
        navigate("/", {
          state: {
            selectedHomeSection: sectionName,
          }
        })
      }
    }, [navigate]);
  return (
    <Container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: { xs: 4, sm: 8 },
        py: { xs: 8, sm: 10 },
        textAlign: { sm: 'center', md: 'left' },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          width: '100%',
          justifyContent: 'space-between',
        }}
      >
        <SitemarkIcon customCss={{
          display: {xs: "none", sm: "inherit"}
        }}/>
        <Box
          sx={{
            display: { xs: 'flex', sm: 'flex' },
            flexDirection: { xs: 'row', sm: 'column' },
            gap: { xs: 2, sm: 1}
          }}
        >
          {/* <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
            Product
          </Typography> */}
          {/* <Link color="text.secondary" variant="body2" onClick={() => openSection('features')}>
            Services
          </Link>
          <Link color="text.secondary" variant="body2" onClick={() => openSection('highlights')}>
            Highlights
          </Link>
          <Link color="text.secondary" variant="body2" onClick={() => openSection('pricing')}>
            Pricing
          </Link>
          <Link color="text.secondary" variant="body2" onClick={() => openSection('faq')}>
            FAQs
          </Link> */}
        </Box>
        <Box
          sx={{
            display: { xs: 'flex', sm: 'flex' },
            flexDirection: { xs: 'row', sm: 'column' },
            gap: { xs: 2, sm: 1}
          }}
        >
          <Typography variant="body2" sx={{ fontWeight: 'medium', display: { xs: 'flex', sm: 'flex' }, }}>
            Company
          </Typography>
          <RouterLink color="text.secondary" to="/aboutus">
            About us
          </RouterLink>
          <RouterLink color="text.secondary" to="/legal">
            Legal
          </RouterLink>
          <Link color="text.secondary" variant="body2" href="mailto:contact@aliatis.io">
            Contact
          </Link>
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          pt: { xs: 4, sm: 8 },
          width: '100%',
          borderTop: '1px solid',
          borderColor: 'divider',
        }}
      >
        <div>
          <Copyright />
        </div>
        <Stack
          direction="row"
          spacing={1}
          useFlexGap
          sx={{ justifyContent: 'left', color: 'text.secondary' }}
        >
          <IconButton
            color="inherit"
            size="small"
            href="https://www.youtube.com/@aliatistech"
            aria-label="Youtube"
            sx={{ alignSelf: 'center' }}
          >
            <YoutubeIcon />
          </IconButton>
          <IconButton
            color="inherit"
            size="small"
            href="https://www.linkedin.com/company/105314428"
            aria-label="LinkedIn"
            sx={{ alignSelf: 'center' }}
          >
            <LinkedInIcon />
          </IconButton>
        </Stack>
      </Box>
    </Container>
  );
}
